/** True after the first authenticated bootstrap has queued deferred file/agent hydration. */
let deferredAuthHydrationQueued = false;

/** Last time `getGlobalInformation` completed during bootstrap, runBootstrap, or throttled layout refresh. */
let lastSessionRevalidatedAt = 0;

export function isDeferredAuthHydrationQueued() {
  return deferredAuthHydrationQueued;
}

export function setDeferredAuthHydrationQueued(queued) {
  deferredAuthHydrationQueued = queued;
}

export function getLastSessionRevalidatedAt() {
  return lastSessionRevalidatedAt;
}

export function setLastSessionRevalidatedAt(ts) {
  lastSessionRevalidatedAt = ts;
}

/** Clears loader session cache so the next authenticated navigation forces a Cognito refresh. */
export function invalidateSessionLoaderState() {
  deferredAuthHydrationQueued = false;
  lastSessionRevalidatedAt = 0;
}
